import React, { useState, useEffect} from "react";
import {CommonDialogBox} from "components";
import { Box, Typography, Stack, DialogProps, Button, CircularProgress, Alert, Tooltip, Grid2 as Grid  } from "@mui/material";
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { HDatums, VDatums, Units, Projections } from "constants/common";
import { useDispatch, useSelector} from 'react-redux';
import { closeDialog} from 'store/main/viewObjects';
import { RootState } from 'store';
import { styled } from "@mui/material/styles";
import { getCachedData } from "api/Cache";
import { LocalizationProvider, MobileDateTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import axios from 'axios';
import LinearProgress from '@mui/material/LinearProgress';
import AlertNotification from "components/AlertNotification";
import EventsEmitter from "events/EventsEmitter";
import { CircularProgressWithLabel } from "components";
import jwtService from 'services/jwtService';
import AuthService from "services/AuthService";
import { config } from "config";
import { updateData } from "services/CacheService";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import {BlockModelTypes, BlockModelModes, validUploadFilesExtensions} from "constants/common";
import { trackEvent } from "components/Tracking";
import { addNotification } from 'components/notificationPanel/store/dataSlice';
import NotificationModel from 'components/notificationPanel/model/NotificationModel';
import { addRawData } from "store/main/selectedRawData";
import { useHistory } from 'react-router-dom';
import {
    setAddObjectState,
    addAutomaticProcess,
    closeObjectDialog
} from "store/main/viewObjects";
import { Scrollbars } from "react-custom-scrollbars";
import { tss } from "tss-react/mui";
import { ReactComponent as PointCloud } from 'assets/images/ic_point-cloud.svg';
import { ReactComponent as Ortho } from 'assets/images/ortho.svg';
import { ReactComponent as IndexedMesh } from 'assets/images/idxmesh.svg';
import { ReactComponent as BlockModel } from 'assets/images/rawbm.svg';
import FlightIcon from '@mui/icons-material/Flight';
import TerrainIcon from '@mui/icons-material/Terrain';

export const useStyles = tss.create(({ theme }) => ({
    objectItem: {
        padding: '10px 5px', 
        borderRadius: '8px', 
        margin: '5px 0 5px 0', 
        flexDirection: 'column', 
        display:'flex', 
        textAlign: 'center', 
        width:'150px', 
        boxShadow: theme.shadows[4],
        "&:not(.disabled):hover": {
            backgroundColor: '#cccccc30',
            "& a": {
                color: theme.palette.primary.main
            },
            "& svg": {
                color: theme.palette.primary.main,
                fill: theme.palette.primary.main,
                "& path": {
                    stroke: theme.palette.primary.main,
                }
            },
        },
        '& a': {
            textDecoration : 'none',
            color: theme.palette.text.secondary,
            whiteSpace: 'nowrap'
        },
        "& svg": {
            color: theme.palette.text.primary,
            fill: theme.palette.text.primary,
            "& path": {
                stroke: theme.palette.text.primary,
            }
        },
        "&.disabled": {
            pointerEvents: 'none',
            opacity: '.2'
        }
    },
    mainTitle: {
        fontWeight:500, 
        marginBottom: '10px', 
        fontSize: '18px',
        padding: "8px 12px",
        backgroundColor: "rgba(32,32,32,.05)",
        width: "100%",
        "& span": {
            color: theme.palette.primary.main,
            " &.subtitle": {
                color: theme.palette.text.secondary,
                fontSize: '14px',
            }
        },
        display:'flex',
        justifyContent: 'space-between'
    },
    supportedFiles: {
        color : theme.palette.primary.main
    },
    helpText: {
        fontSize: '15px',
        LineWeight: '23px',
        margin: '0px',
        padding: '0px 0px 10px 0px',
        "& ul": {
            columns: 2,
            columnGap: '20px'
        }
    }
}))
type CD = {
    header : string,
    type : string,
    mode : string,
    num : Number
};


dayjs.extend(utc);
dayjs.extend(timezone);
const EST = "America/New_York";

function CreateObjPanel(props:any) {
    const data = getCachedData();
    const {project, catalogId, isFolder} = props;
    const { classes } = useStyles();
    const dispatch = useDispatch();
    const org = config.org;
    const [files, setFiles] = useState<any>([]);
    const [itemName, setItemName] = useState('')
    const [itemNameError, setItemNameError] = useState(false)
    const [helperItemName, setHelperItemName] = useState('')
    const [columnmeta, setColumnMeta] = useState('')
    const [csvheader, setCsvheader] = useState('')
   
    //const [captureDate, setCaptureDate] = useState(dayjs.tz(dayjs(), EST));
    const [captureDate, setCaptureDate] = useState<any>(null)
    const [horizontalDatum, setHorizontalDatum] = useState('')
    const [verticalDatum, setVerticalDatum] = useState('')
    const [projections, setProjections] = useState('')
    const [horizontalUnits, setHorizontalUnits] = useState('')
    const [verticalUnits, setVerticalUnits] = useState('')
    const [selectedFile, setSelectedFile] = useState(false);
    const [fileType, setFileType] = useState('RAWPC');
	const [message, setMessage] = useState('')
	const [alertType, setAlertType] = useState('')
	const [loading, setLoading] = useState(false)
	const [progress, setProgress] = useState(false)
  	const [uploadProgress, setUploadProgress] = useState<any>([]);
  	const [remainingTime, setRemainingTime] = useState<any>([]);
    const [isUploading, setIsUploading] = useState(false);
    const [entity, setEntity] = useState<any>(null);
    const [columnList, setColumnList] = useState<any[]>([])
    const [isDragging, setIsDragging] = useState(false);
    const [selectedRawData, setSelectedRawData] = useState<string[]>([])
    const [currentType, setCurrentType] = useState('SKIP');
    const [currentMode, setCurrentMode] = useState('AVERAGE');
    const [currentNumber, setCurrentNumber] = useState(0);
    const [minHeight, setMinHeight] = useState(0);
    const [maxHeight, setMaxHeight] = useState(0);
    const [currentId, setCurrentId] = useState('')
    const [fileAllowedExtensions, setFileAllowedExtensions] = useState<any[]>([])
    const [filesError, setFilesError] = useState('')
    const [maxFileSize, setMaxFileSize] = useState(0)
    const [sizeb, setSize] = useState(0)
    const [progressLoading, setProgressLoading] = useState(0);
    const viewObject = useSelector((state: RootState) => state.main.viewObject);
    const storeAuthData = useSelector((state: any) => state.auth.data);
    const { usageData: { storage }, limit_storage } = storeAuthData;
    const { objName, state:open, addOjectState, automaticProcess } = viewObject;
    const history = useHistory();
    const [showForm, setShowForm] = useState(open || addOjectState)
 
    const closeComposeDialog: DialogProps["onClose"] = (event, reason) => {
        if (reason && reason === "backdropClick")
            return;

        if(reason === "escapeKeyDown")
             cancel()
    }

	const cancel = () => {
		setFiles([])
		dispatch(closeDialog({}))

		setProgress(false)
		setLoading(false)
        setShowForm(true)
        setCsvheader('')
        setColumnList([])
        setCurrentType('SKIP')
        setCurrentMode('AVERAGE')
        setCurrentNumber(0);
        dispatch(closeObjectDialog({}));
        automaticProcess && dispatch(setAddObjectState(false));
        trackEvent("Raw Data", objName, "close");
        
	}
 
    const handleName = (e:any) => {
        setItemName(e.target.value)
        if(e.target.value === ''){
            setItemNameError(true);
            setHelperItemName("Please select a name");
        }else{
            setItemNameError(false);
            setHelperItemName("");
        }
    }

    useEffect(() => {
        console.log("Name : " + itemName)
        if (!entity) return;
        if (progress) return;
        if (alertType !== 'success') return;
        dispatch(closeDialog({}))
        updateData("update", "entities", entity.project, entity, (id: string) => {});
    }, [entity, progress, alertType, itemName])

    useEffect(() => {
        setMaxFileSize(limit_storage * 1024 * 1024 * 1024 - storage)
    }, [storage, limit_storage])

    useEffect(() => {
        if(!objName) return;
        if(!validUploadFilesExtensions[objName]) return;

        const exts = validUploadFilesExtensions[objName].reduce((fileAllowedExtensions: any[], ext: string) => ([
            ...fileAllowedExtensions,
            `.${ext}`
        ]), []);
        setFileAllowedExtensions(exts);
    }, [validUploadFilesExtensions, objName])

    const CustomTextField = styled(TextField)({
        "& .MuiInputBase-root": {
          height: "40px", // Set your desired height
        },
    });

    const handleFileChange = (
        event: React.ChangeEvent<HTMLInputElement> | React.DragEvent<HTMLDivElement>
        ) => {
        let selectedFiles: File[] = [];

        if ('dataTransfer' in event) {
            // Drag event
            event.preventDefault();
            selectedFiles = Array.from(event.dataTransfer.files);
        } else if (event.target && event.target.files) {
            // File input
            selectedFiles = Array.from(event.target.files);
        }

        if (selectedFiles.length === 0) return;

        const validFiles = selectedFiles.filter((file) => {
            const ext = file.name.split('.').pop()?.toLowerCase();
            return fileAllowedExtensions.includes(`.${ext}`);
        });

        let error = '';

        if (validFiles.length !== selectedFiles.length) {
            error = 'One or more file types are not allowed.';
        }

        const filesSize = validFiles.reduce((total, file) => total + file.size, 0);
        if (filesSize > maxFileSize) {
            error = `The file size exceeds the maximum limit of ${maxFileSize} byte(s).`;
        }

        if (error) {
            setFilesError(error);
            setTimeout(() => setFilesError(''), 7500);
            if ('target' in event) {
            // Clear input if from file input
            (event.target as HTMLInputElement).value = '';
            }
            return;
        }

        setFilesError('');
        setLoading(false);
        setFiles(validFiles);
        setSelectedFile(true);
        setUploadProgress(new Array(validFiles.length).fill(0));
        setRemainingTime(new Array(validFiles.length).fill(''));
    };


    // const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     if (!(event.target.files && event.target.files.length > 0)) return;

    //     const selectedFiles = [...event.target.files];
    //     const files = selectedFiles.filter((file) => {
    //         const ext = file.name.split('.').pop();
    //         return fileAllowedExtensions.includes(`.${ext}`);
    //     });
    //     let error = '';
        
    //     if (files?.length !== selectedFiles.length) 
    //         error = 'One or more file types are not allowed.';
        
    //     const filesSize = files.reduce((size:number, file) => size + file.size, 0)
    //     if (filesSize > maxFileSize)  error = `The file size exceeds the maximum file size limit of ${maxFileSize} byte(s).`

    //     setFilesError(error);
    //     if(error) {
    //         setFilesError(error)
    //         setTimeout(() => {
    //             setFilesError('')
    //         }, 7500);
    //         event.target.value = '';
    //         return;
    //     }
    //     setLoading(false)
    //     setFiles([...files]);  
    //     setSelectedFile(true)
    //     setUploadProgress(new Array(files.length).fill(0));
    //     setRemainingTime(new Array(files.length).fill(''));
    // };

    const getEstimatedTime = (timeInSeconds: number) => {
        const hours = Math.floor(timeInSeconds / 3600);
        const minutes = Math.floor(timeInSeconds / 60 - hours * 60);
        const seconds = Math.floor(timeInSeconds - minutes * 60 - hours * 3600);

        let timeString = `${seconds} sec`;
        minutes && (timeString = `${minutes} min ${timeString}`);
        hours && (timeString = `${hours} hrs ${timeString}`);

        return timeString;
    }

    useEffect(() => {
      setShowForm(true)
    }, [])

    useEffect(() => {
        if (selectedRawData.length === 0) return;
        dispatch(addRawData(selectedRawData));
    }, [selectedRawData]);
    

    const DialogAction = () => {
        return (
            showForm ? 
            <>
                <Button onClick={cancel}>Cancel</Button>
                <Button 
                    variant="contained"
                    color="primary"
                    disabled={!selectedFile}
                    type="submit" onClick={() => {
                        trackEvent("Raw Data", objName, "Create");
                        handleUpload();
                    }}
                    sx={{
                        '&.Mui-disabled': {
                            backgroundColor: (theme) => theme.palette.background.default,
                            color: (theme) => theme.palette.text.disabled,
                            opacity: '.75'
                        },
                    }}
                >
                    { isUploading ? "Uploading" : "Create"}
                </Button>
            </>
            : ''
        )
    }
    
    const AddProcessDialogAction = () => {
        return (
            <>
                <Button
                    type="button"
                    color="primary"
                    variant="outlined"
                    fullWidth
                    sx={{
                        width: 105
                    }}
                    onClick={(e) => {
                        cancel();
                    }}
                    aria-label="Cancel"
                    title="Cancel"
                >
                    Cancel
                </Button>
            </>
        )
    }
    
    const showProcessPanel = (e:any, objName:string) => {
        e.preventDefault()
        cancel();
        setTimeout(() => {
            dispatch(addAutomaticProcess({ objName, project }));
        }, 1000);
    }
    

  const AddProcessDialog = (props:any) => {
      const { classes, cx } = useStyles();
  
      return (
          <>
              <Scrollbars
                  autoHeight
                  autoHeightMax={600}
                  style={{ overflowX: "hidden", width: "100%" }}
              >
                  <div style={{paddingRight: '10px'}}>
                      <div style={{ display:'flex', flexDirection:'column', justifyContent: 'space-between', width: "100%", paddingBottom: '0px'}}>
                          <p className={classes.helpText }>Once your raw data is imported into the system, VoxelSpace allows you to convert it into formats optimized for analysis and visualization. 
                            Select your desired conversion format from the list below.
                              <Grid container spacing={2}>
                                <Grid  size={{sm:6, md:4, lg:3, xl:3}}>    
                                    <div className={cx(classes.objectItem, objName !== 'Point Cloud' && 'disabled')}>
                                        <a href="/#" 
                                            onClick={(e) => {
                                                e.preventDefault()
                                                trackEvent("Process", "Voxel Terrain", "Open");
                                                showProcessPanel(e, 'Voxel Terrain');
                                            }}
                                            >
                                            <div><Ortho style={{height:"30px", width:"30px"}} /></div>
                                            <div>Voxel Terrain</div>
                                        </a>
                                    </div>
                                </Grid>
                                <Grid  size={{sm:6, md:4, lg:3, xl:3}}>    
                                    <div className={cx(classes.objectItem, objName !== 'Point Cloud' && 'disabled')}>
                                        <a href="/#" 
                                            onClick={(e) => {
                                                e.preventDefault()
                                                trackEvent("Process", "Indexed Point", "Open");
                                                showProcessPanel(e, 'Indexed Point');
                                            }}
                                        >
                                            <div><PointCloud  style={{height:"30px", width:"30px"}}/></div>
                                            <div>Indexed Points</div>
                                        </a>
                                    </div>
                                </Grid>
                                 <Grid  size={{sm:6, md:4, lg:3, xl:3}}>    
                                    <div className={cx(classes.objectItem, objName !== 'Drill Holes' && 'disabled')}>
                                        <a href="/#" 
                                            onClick={(e) => {
                                                e.preventDefault()
                                                trackEvent("Process", "Drill Hole Database", "Open");
                                                showProcessPanel(e, 'Drill Hole Database');
                                            }}
                                        >
                                            <div><FlightIcon  style={{height:"30px", width:"30px"}} /></div>
                                            <div>Drill Hole Database</div>
                                        </a>
                                    </div>
                                </Grid>
                                <Grid  size={{sm:6, md:4, lg:3, xl:3}}>    
                                    <div className={cx(classes.objectItem, objName !== 'Geo Chem' && 'disabled')}>
                                        <a href="/#" 
                                            onClick={(e) => {
                                                e.preventDefault()
                                                trackEvent("Process", "Geo Chem", "Open");
                                                showProcessPanel(e, 'Geo Chem');
                                            }}
                                        >
                                            <div><FlightIcon  style={{height:"30px", width:"30px"}} /></div>
                                            <div>Geo Chem</div>
                                        </a>
                                    </div>
                                </Grid>
                                <Grid  size={{sm:6, md:4, lg:3, xl:3}}>    
                                    <div className={cx(classes.objectItem, objName !== 'Mesh' && 'disabled')}>
                                        <a href="/#" 
                                            onClick={(e) => {
                                                e.preventDefault()
                                                trackEvent("Process", "Ortho Voxel Terrain", "Open");
                                                showProcessPanel(e, 'Ortho Voxel Terrain');
                                            }}
                                        >
                                            <div><Ortho  style={{height:"30px", width:"30px"}} /></div>
                                            <div>Ortho Voxel Terrain</div>
                                        </a>
                                    </div>
                                </Grid>
                                <Grid  size={{sm:6, md:4, lg:3, xl:3}}>    
                                    <div className={cx(classes.objectItem, objName !== 'Mesh' && 'disabled')}>
                                        <a href="/#" 
                                            onClick={(e) => {
                                                e.preventDefault()
                                                trackEvent("Process", "Voxelized Mesh", "Open");
                                                showProcessPanel(e, 'Voxelized Mesh');
                                            }}
                                        >
                                            <div><TerrainIcon style={{fontSize:"30px"}} /></div>
                                            <div>Voxelized Mesh</div>
                                        </a>
                                    </div>
                                </Grid>
                                <Grid  size={{sm:6, md:4, lg:3, xl:3}}>    
                                    <div className={cx(classes.objectItem, objName !== 'Mesh' && 'disabled')}>
                                        <a href="/#" 
                                            onClick={(e) => {
                                                e.preventDefault()
                                                trackEvent("Process", "Indexed Mesh", "Open");
                                                showProcessPanel(e, 'Indexed Mesh');
                                            }}
                                        >
                                            <div><IndexedMesh  style={{height:"30px", width:"30px"}} /></div>
                                            <div>Indexed Mesh</div>
                                        </a>
                                    </div>
                                </Grid>
                                <Grid  size={{sm:6, md:4, lg:3, xl:3}}>    
                                    <div className={cx(classes.objectItem, objName !== 'Ortho-Imagery' && 'disabled')}>
                                        <a href="/#" 
                                            onClick={(e) => {
                                                e.preventDefault()
                                                trackEvent("Process", "Indexed Imagery", "Open");
                                                showProcessPanel(e, 'Indexed Imagery');
                                            }}
                                        >
                                            <div><FlightIcon  style={{height:"30px", width:"30px"}} /></div>
                                            <div>Indexed Imagery</div>
                                        </a>
                                    </div>
                                </Grid>
                               
                                <Grid  size={{sm:6, md:4, lg:3, xl:3}}>    
                                    <div className={cx(classes.objectItem, objName !== 'Block Model' && 'disabled')}>
                                        <a href="/#" 
                                            onClick={(e) => {
                                                e.preventDefault()
                                                trackEvent("Process", "Voxel Block Model", "Open");
                                                showProcessPanel(e, 'Voxel Block Model');
                                            }}
                                    >
                                            <div><BlockModel  style={{height:"30px", width:"30px"}} /></div>
                                            <div>Voxel Block Model</div>
                                        </a>
                                    </div>
                                </Grid>
                            </Grid>
                          </p>
                      </div> 
                  </div>
              </Scrollbars>
          </>
      )
  
  }

    const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        //e.currentTarget.style.border = '2px dashed #1976d2';
        setIsDragging(true);
    };

    const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        //e.currentTarget.style.border = '2px dashed #ccc';
        setIsDragging(false);
    };

    const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        handleFileChange(e);
        trackEvent("Raw Data", objName, "Drag file");
        //e.currentTarget.style.border = '2px dashed #ccc';
        setIsDragging(false);
    };


 	const uploadFilesRecursively = async (files:any, index = 0, id : any, sizeb = 0, uploadedSize = 0) => {

        const totalSize:any = Array.from(files).reduce((sum, file:any) => sum + file.size, 0);
        setSelectedRawData(prev => {
            if (prev.includes(id)) {
                return prev;
            }
            const newState = [...prev, id];
            return newState;
        });

      	// Base case: Stop recursion when all files are processed
		if (index >= files.length) {
            const requestData = {
                state: "COMPLETE",
                file_size: totalSize
            }
            try{
                const response = await jwtService.fetchRequest({
                    method: 'POST',
                    url: `/entity.ashx?id=${id}&project=${project}`,
                    data: requestData,
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    }
                });

                setTimeout(() => {
                    dispatch(setAddObjectState(response.data.result === 'success'));
                }, 3000)
                if(response.data.result === 'success') {
                    setAlertType('success')
                    setIsUploading(false);
                    setMessage('File uploading successfully completed')
                    setProgress(false);
                    dispatch(addNotification(NotificationModel({ message: 'File uploaded. Create a process to generate outputs, or upload more files.', options: { variant: 'success', autoHideDuration: 8000 } })));
                    console.log("SelectedRawData : " + selectedRawData)
                } else{
                    setAlertType('error')
                    setMessage('An error occurs during the upload process');
                    setShowForm(false)
                    setProgress(false);
                }
                EventsEmitter.emit("reloadData", "");
            } catch(e) {
                console.error(e);
                setAlertType('error')
                setMessage('An error occurs during the upload process');
                setShowForm(false)
                setProgress(false);
            }
            return;
		}
	
		const file = files[index];
		const formData = new FormData();
		formData.append("file", file);
	
		try {
			// Simulate file upload with fetch API
	        const url = config.api.baseUrl + config.api.endpoints["file"] + `?project=${project}&id=${id}&org=${org}&partialsize=${sizeb}`;

            const formData = new FormData();
			formData.append('file', file);
                    
			const response = await axios.post(url, formData, {
				headers: { 
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${AuthService.getToken()}`,
                 },
                // onDownloadProgress : onUploadProgress
                onUploadProgress: (progressEvent) => {
                    if (progressEvent.total) {
                        const remainingTime = getEstimatedTime(progressEvent.estimated || 0);
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        uploadedSize += progressEvent.loaded;
                        //const overallProgress = Math.round((uploadedSize / totalSize) * 100);
                        //console.log(`Overall Progress : ${overallProgress}%`)
                        setMessage(`${file?.name} Upload progress: ${percentCompleted}% ${remainingTime}`);

                        setUploadProgress((prevProgress:any) => {
                            const updatedProgress = [...prevProgress];
                            updatedProgress[index] = percentCompleted;
                            return updatedProgress; // Set progress to 100% for the current file
                        });
                        setRemainingTime((state:any) => {
                            const oldState = [...state];
                            oldState[index] = remainingTime;
                            return oldState;
                        });

                    } else {
                        console.log(`Uploaded ${progressEvent.loaded} bytes (total unknown)`);
                    }
                },
			});

			// Recursively upload the next file
			uploadFilesRecursively(files, index + 1, id, response.data.size, uploadedSize);

		} catch (error) {
			console.error(error);
            setAlertType('error')
            setMessage('An error occurs during the upload process');
            setProgress(false)
		}
	};


    const uploadFiles = async (files:any) => {
        const totalSize:any = Array.from(files).reduce((sum, file:any) => sum + file.size, 0);
        const allowedExtensions = validUploadFilesExtensions[objName];

        console.log('objName : ' + objName);
       
        let invalidFiles = [];
        for(let i=0 ; i < files.length ; i++) {
            const isTextByMime = files[i].type === 'text/plain' && objName !== 'Mesh';
            const fileName = files[i].name;
            const extension = fileName.split('.').pop().toLowerCase();
            const isValidExtension = allowedExtensions.includes(extension);
             if (!isValidExtension && !isTextByMime) {
                invalidFiles.push(fileName);
            }
        }

        if (invalidFiles.length > 0) {
            setLoading(true)
            setAlertType('error')
            const fullExtensions = allowedExtensions.map((ext:string) => ' .' + ext);
            setMessage(`Please provide with a valid "${objName}" file (${fullExtensions} )`)
            return;
        }

        const progressContainer = document.getElementById('progressContainer')
        if (!progressContainer) {
            console.error('Progress container element not found');
            return; // Stop execution if the container is missing
        }
        progressContainer.innerHTML = ''; // Clear previous progress info
		//setSize(0)
		setProgress(true)
		setLoading(true)
		setAlertType('warning')
		setMessage('Please keep this tab open until the upload process completes')

        let requestData = {
            name: itemName,
            capture_date: captureDate.valueOf().toString(),
            type: "FILE",
            state: "PARTIAL",
            file_type: fileType,
            file_size: "0",
            file_date: Date.now().toString(),
            file_folder: isFolder ? catalogId : "0",
            entity_coord_hunit: horizontalUnits,
            entity_coord_vunit: (objName !== 'Ortho-Imagery' ? verticalUnits : undefined),
            entity_coord_hdatum: horizontalDatum,
            entity_coord_vdatum:  (objName !== 'Ortho-Imagery' ? verticalDatum : undefined),
            entity_coord_projection: projections,
            elevation_min: (objName === 'Heightmap' ? minHeight.toString() : undefined),
            elevation_max: (objName === 'Heightmap' ? maxHeight.toString() : undefined)
        }

        const meta = columnList.map((item) => (item['header'] + ' ' + item['type'] + ' ' + item['mode'] + ' ' + item['num']));

        try{
            const response = await jwtService.fetchRequest({
                method: 'POST',
                url: `/entity.ashx?project=${project}`,
                data: (objName === 'Block Model' ? {...requestData, block_model_type: 'octree', column_meta : btoa(meta.join(','))} : requestData),
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            });
    
            if(response.data.result === 'success') {
                setIsUploading(true);
                uploadFilesRecursively(files, 0, response.data.id, 0, 0);
                setEntity({
                    ...requestData,
                    ID: response.data.id,
                    catalogId
                });
            }
        }catch(error) {
            console.error(error);
            setAlertType('error')
            setMessage('An error occurs during the upload process');
            setProgress(false)
        }
    };

    const handleBMType = (e:any, key:any, index:any) => {
        e.preventDefault()
        setCurrentId(index)
        setCurrentType(e.target.value)
        setColumnList((prevUsers) =>
            prevUsers.map((user, i) =>
              i === index ? { ...user, [key]: e.target.value } : user
            )
        );
    }


    const handleBMMode = (e:any, key:any, index:any) => {
        e.preventDefault()
        setCurrentId(index)
        setCurrentMode(e.target.value)
        setColumnList((prevUsers) =>
            prevUsers.map((user, i) =>
              i === index ? { ...user, [key]: e.target.value } : user
            )
        );
        console.log(columnList)
    }

    const handleBMNumber = (e:any, key:any, index:any) => {
        e.preventDefault()
        setCurrentId(index)
        setCurrentNumber(e.target.value)
        console.log("current Number : " + e.target.value)

        setColumnList((prevUsers) =>
            prevUsers.map((user, i) =>
              i === index ? { ...user, [key]: parseInt(e.target.value) } : user
            )
        );
    }

    const handleUpload = async () => {
        if(itemName === ''){
            setItemNameError(true);
            setHelperItemName("Please select the object name");
            return false
        }
        //setShowForm(false)
        console.log("FILES : " + files)
        await uploadFiles(files)
    };

    const handleCsvheader = (val:any) => {
        setCsvheader(val);

        const list = val.split(",").map( (item:any) => (
            {header : item, type : 'SKIP', mode : 'AVERAGE', num : 0}
        ));
        setColumnList(list)
    }

    useEffect(() => {     
       
        const handleProgress = (curProgress: number) => {
            setProgressLoading(curProgress);
        };

        EventsEmitter.on("projects_progress", handleProgress);
        return () => {
            EventsEmitter.removeEventListener("projects_progress", handleProgress);
        };

    }, [data]);


	useEffect(() => {

        if(objName === 'Ortho-Imagery')
            setFileType('ORTHO')

        if(objName === 'Mesh')
            setFileType('RAWMESH')

        if(objName === 'Block Model')
            setFileType('RAWBM')

        if(objName === 'Heightmap')
            setFileType('RAWHM')

        if(objName === 'Drill Holes')
            setFileType('RAWDH')

        if(objName === 'Geo Chem')
            setFileType('RAWGEOCHEM')

        const currentDate = dayjs.tz(new Date(), EST);
        const projects: any = data?.projects?.[project];
        if (!projects) return;
        setCaptureDate(currentDate)
        //setItemName("New " + objName)
        setHorizontalDatum(projects.coord_hdatum ?? "");
        setVerticalDatum(projects.coord_vdatum ?? "");
        setProjections(projects.coord_projection ?? "");
        setHorizontalUnits(projects.coord_unit ?? "");
        setVerticalUnits(projects.coord_unit ?? "");
    }, [objName, data, project])
    
    if (!data.loaded) {
        return progressLoading === 0 ? <CircularProgress /> : <CircularProgressWithLabel value={progressLoading} />;
    }

    return (
		<>
            <CommonDialogBox
                classes={{
                    paper: 'm-24 rounded-8'
                }}
                open={open || addOjectState}
                handleClose={closeComposeDialog}
                fullWidth
                maxWidth= {addOjectState ? "md" : "sm" }
                subtitle1={addOjectState ? "Step 2: Process Spatial Entities" : `Upload ${objName}`}
                titleh5=''
                dialogAction={addOjectState ? <AddProcessDialogAction /> : <DialogAction />}
                displayScrollBar={true}
                maxHeight={600}
                helpLinkCode={addOjectState || !objName ? '' : `project-objects-${objName.replace(/ /g, '-').toLowerCase()}`}
            >
                <div id="progressContainer" style={{ display:'none' }}></div>
                {
                loading && (
                    <>
                    <AlertNotification variant={"standard"} type={alertType} message={message} />
                    {
                    progress && (
                        <Box sx={{ width: '100%' }}>
                            <LinearProgress />
                        </Box>
                        )
                    }
                    </>
                    )
                }
                {
                showForm ? 
                ( addOjectState ? (
                    <AddProcessDialog />
                ) : (
                    <Stack 
                        gap={1}
                    >
                        <Tooltip title="A descriptive, readable name for the new entity" placement="top" arrow>
                            <TextField
                                sx={{
                                    "& .MuiInputBase-root": {
                                    height: "40px", // Set your desired height
                                    },
                                }}
                                required
                                margin="dense"
                                id="itemName"
                                name="itemName"
                                label="Item Name"
                                error={itemNameError}
                                helperText={helperItemName}
                                value={itemName}
                                type="txt"
                                fullWidth
                                color='primary'
                                variant="outlined"
                                onChange={(e) => handleName(e)}
                                style={{marginBottom: '10px'}}
                                autoComplete='off' 
                            /> 
                            </Tooltip>
                            { objName === 'Heightmap' && (
                                <>
                                <Tooltip title="Elevation value for black pixels in the heightmap" placement="top" arrow>
                                <TextField
                                    sx={{
                                        "& .MuiInputBase-root": {
                                        height: "40px", // Set your desired height
                                        },
                                    }}
                                    required
                                    margin="dense"
                                    id="minHeight"
                                    name="minHeight"
                                    label="Minimum Height"
                                    value={minHeight}
                                    type="txt"
                                    fullWidth
                                    color='primary'
                                    variant="outlined"
                                    onChange={(e) => setMinHeight(Number(e.target.value))}
                                    style={{marginBottom: '10px'}}
                                /> 
                                </Tooltip>
                                <Tooltip title="Elevation value for white pixels in the heightmap" placement="top" arrow>
                                <TextField
                                    sx={{
                                        "& .MuiInputBase-root": {
                                        height: "40px", // Set your desired height
                                        },
                                    }}
                                    required
                                    margin="dense"
                                    id="maxHeight"
                                    name="maxHeight"
                                    label="Maximum Height"
                                    value={maxHeight}
                                    type="txt"
                                    fullWidth
                                    color='primary'
                                    variant="outlined"
                                    onChange={(e) => setMaxHeight(Number(e.target.value))}
                                    style={{marginBottom: '10px'}}
                                /> 
                                </Tooltip>
                                </>
                            )}
                        
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en">
                                
                                <MobileDateTimePicker
                                    label="Capture Date"
                                    format="MM/DD/YYYY hh:mm A"
                                    value={captureDate}
                                    ampm={true}
                                    onChange={(newValue) => setCaptureDate(dayjs.tz(newValue, EST))}
                                    //onChange={(newValue) => setCaptureDate(newValue)}
                                    sx={{
                                        "& .MuiInputBase-root": {
                                            height: "40px", // Set your desired height
                                            "& .MuiInputBase-input": {
                                                paddingTop: '8px !important'
                                            }
                                        },
                                        //backgroundColor: (theme: any) => theme.components.MuiInputBase.styleOverrides.root.background
                                    }}
                                    slotProps={{
                                        textField: {
                                            fullWidth: true,
                                            InputProps: {
                                            // Wrap the input field (not the raw <input />) in a Tooltip
                                            components: {
                                                Root: (props) => (
                                                <Tooltip title="Select the date and time when the capture was made" placement="top" arrow>
                                                    <div {...props} />
                                                </Tooltip>
                                                ),
                                            },
                                            },
                                        },
                                    }}
                                />
                            </LocalizationProvider>
                        
                            { objName === 'Mesh' && (
                            
                                <TextField
                                    sx={{
                                        "& .MuiInputBase-root": {
                                        height: "40px", // Set your desired height
                                        },
                                    }}
                                    required
                                    margin="dense"
                                    id="columnmeta"
                                    name="columnmeta"
                                    label="Column Meta"
                                    value={columnmeta}
                                    type="txt"
                                    fullWidth
                                    color='primary'
                                    variant="outlined"
                                    onChange={(e) => setColumnMeta(e.target.value)}
                                    style={{marginBottom: '10px'}}
                                /> 
                                
                            )}

                            { objName === 'Block Model' && (
                                <Tooltip title={
                                    <>
                                    The CSV Header field defines how each column in your file should be interpreted. 
                                    Click on the help icon <HelpOutlineIcon fontSize="inherit" /> above for more details.
                                    </>
                                } placement="top" arrow>
                                <TextField
                                    sx={{
                                        "& .MuiInputBase-root": {
                                        height: "40px", // Set your desired height
                                        },
                                    }}
                                    required
                                    margin="dense"
                                    id="csvheader"
                                    name="csvheader"
                                    label="CSV Header"
                                    value={csvheader}
                                    type="txt"
                                    fullWidth
                                    color='primary'
                                    variant="outlined"
                                    onChange={(e) => handleCsvheader(e.target.value)}
                                    style={{marginBottom: '10px'}}
                                />
                                </Tooltip> 
                            )}

                            {
                                columnList.length > 0 && (
                                    columnList.map((item:any, index:any) => (
                                        item.header !== '' ? 
                                        <div style={{display: 'flex', alignItems:'center', justifyItems: 'flex-start', justifyContent: 'space-between'}}>
                                            <div style={{ width:"50px", textAlign:'center'}}>{columnList[index]['header']}</div>  
                                            <div>
                                            <CustomTextField
                                                sx={{
                                                    "& .MuiInputBase-root": {
                                                    height: "40px", // Set your desired height
                                                    width: '130px'
                                                    },
                                                }}
                                                required
                                                margin="dense"
                                                id="bmtype"
                                                name="bmtype"
                                                select
                                                type="txt"
                                                fullWidth
                                                value={ columnList[index]['type']}
                                                color='primary'
                                                variant="outlined"
                                                onChange={(e) => handleBMType(e, "type", index)}
                                            >
                                                {
                                                    BlockModelTypes.map(item => <MenuItem value={item.value} key={item.value}>{item.text}</MenuItem>)
                                                }
                                            </CustomTextField> 
                                            </div>
                                            <div>
                                            <CustomTextField
                                            sx={{
                                                "& .MuiInputBase-root": {
                                                height: "40px", // Set your desired height
                                                width: '130px'
                                                },
                                            }}
                                                required
                                                margin="dense"
                                                id="bmmode"
                                                name="bmmode"
                                                type="txt"
                                                select
                                                fullWidth
                                                value={ columnList[index]['mode']}
                                                color='primary'
                                                variant="outlined"
                                                onChange={(e) => handleBMMode(e, "mode", index)}
                                            >
                                                {
                                                    BlockModelModes.map(item => <MenuItem value={item.value} key={item.value}>{item.text}</MenuItem>)
                                                }
                                            </CustomTextField> 
                                            </div> 
                                            <div>
                                            <TextField
                                                sx={{
                                                    "& .MuiInputBase-root": {
                                                    height: "40px", // Set your desired height
                                                    width: "130px"
                                                    },
                                                }}
                                                required
                                                margin="dense"
                                                id="bmnumber"
                                                name="bmnumber"
                                                value={ columnList[index]['num']}
                                                type="txt"
                                            
                                                color='primary'
                                                variant="outlined"
                                                onChange={(e) => handleBMNumber(e, "num", index)}
                                            />
                                            </div>
                                        </div>
                                        : ''
                                    ))
                                )
                            }

                            <Tooltip title="The horizontal reference system used" placement="top" arrow>
                            <CustomTextField
                                sx={{
                                    "& .MuiInputBase-root": {
                                    height: "40px", // Set your desired height
                                    },
                                }}
                                required
                                margin="dense"
                                id="horizontaldatum"
                                name="horizontaldatum"
                                label="Horizontal datum"
                                type="txt"
                                select
                                fullWidth
                                value={horizontalDatum}
                                color='primary'
                                variant="outlined"
                                onChange={(e) => setHorizontalDatum(e.target.value)}
                            > 
                                {
                                    HDatums.map(item => <MenuItem value={item.value} key={item.value}>{item.text}</MenuItem>)
                                }
                            </CustomTextField> 
                            </Tooltip>
                            { objName !== 'Ortho-Imagery' && (
                            <Tooltip title="The vertical reference system used for elevation or depth" placement="top" arrow>
                                <CustomTextField
                                    required
                                    margin="dense"
                                    id="verticaldatum"
                                    name="verticaldatum"
                                    label="Vertical datum"
                                    type="txt"
                                    select
                                    fullWidth
                                    value={verticalDatum}
                                    color='primary'
                                    variant="outlined"
                                    onChange={(e) => setVerticalDatum(e.target.value)}
                                >
                                    {
                                        VDatums.map(item => <MenuItem value={item.value} key={item.value}>{item.text}</MenuItem>)
                                    }
                                </CustomTextField> 
                            </Tooltip>
                            )}
                            <Tooltip title="The coordinate projection applied to the dataset" placement="top" arrow>
                                <CustomTextField
                                    required
                                    margin="dense"
                                    id="projection"
                                    name="projection"
                                    label="Projection"
                                    type="txt"
                                    select
                                    fullWidth
                                    value={projections}
                                    color='primary'
                                    variant="outlined"
                                    onChange={(e) => setProjections(e.target.value)}
                                >
                                    {
                                        Projections.map(item => <MenuItem value={item.value} key={item.value}>{item.text}</MenuItem>)
                                    }
                                </CustomTextField> 
                            </Tooltip>
                            <Tooltip title="Units used for horizontal measurements (e.g., meters or feet)" placement="top" arrow>
                                <CustomTextField
                                    required
                                    margin="dense"
                                    id="horizontalUnits"
                                    name="horizontalUnits"
                                    label="Horizontal Units"
                                    type="txt"
                                    select
                                    fullWidth
                                    value={horizontalUnits}
                                    color='primary'
                                    variant="outlined"
                                    onChange={(e) => setHorizontalUnits(e.target.value)}
                                >
                                    {
                                        Units.map(item => <MenuItem value={item.value} key={item.value}>{item.text}</MenuItem>)
                                    }
                                </CustomTextField>
                            </Tooltip> 
                            { objName !== 'Ortho-Imagery' && (
                                <Tooltip title="Units used for vertical measurements (e.g., meters or feet)" placement="top" arrow>
                                    <CustomTextField
                                        required
                                        margin="dense"
                                        id="verticalUnits"
                                        name="verticalUnits"
                                        label="Vertical Units"
                                        type="txt"
                                        select
                                        fullWidth
                                        value={verticalUnits}
                                        color='primary'
                                        variant="outlined"
                                        onChange={(e) => setVerticalUnits(e.target.value)}
                                    >
                                        {
                                            Units.map(item => <MenuItem value={item.value} key={item.value}>{item.text}</MenuItem>)
                                        }
                                    </CustomTextField>
                                </Tooltip>
                            )}

                            
                            <Box 
                                display="flex" 
                                flexDirection="row" 
                                alignItems="center" 
                                justifyContent="space-between" 
                                gap={2} 
                                style={{ marginTop: "5px", minHeight: "80px", cursor: "pointer", padding: '10px' }}
                                onDrop={handleDrop}
                                onDragOver={handleDragOver}
                                onDragLeave={handleDragLeave}
                                border="2px dashed"
                                borderColor={isDragging ? "#1976d2" : "grey.400"}
                                >

                                    <div style={{ flex: 1 }}>
                                        {
                                            files.length > 0 ? (
                                                files.map((file: any, index: any) => (
                                                    <Typography
                                                        variant="body1"
                                                        style={{ display: 'flex', fontSize: '11px', padding: '0 10px' }}
                                                        key={index}
                                                    >
                                                        {file.name}
                                                    </Typography>
                                                ))
                                            ) : (
                                                <Typography
                                                    variant="body2"
                                                    style={{ textAlign: 'center', color: '#999', fontStyle: 'italic', fontSize: '13px' }}
                                                >
                                                    Drop your file here
                                                </Typography>
                                            )
                                        }
                                    </div>

                            
                                {/* <div>
                                    { 
                                    files.length > 0 && (
                                        files.map((file:any, index:any) => (
                                            <Typography variant="body1" style={{ display:'flex', fontSize: '11px', padding:' 0 10px' }} key={index}> {file.name}<div style={{fontWeight:'600'}}></div></Typography>                                   
                                        ))
                                    )}
                                </div> */}
                                
                                <input
                                    accept={fileAllowedExtensions.join()}
                                    style={{ display: "none", marginBottom:'10px' }}
                                    id="file-upload"
                                    multiple={objName === 'Mesh' ? false : true}
                                    type="file"
                                    onChange={(e) => {
                                        trackEvent("Raw Data", objName, "choose File");
                                        handleFileChange(e);
                                    }}
                                />
                                <label htmlFor="file-upload">
                                    <Button variant="contained" color="info" component="span">
                                    Choose File
                                    </Button>
                                </label>
                            </Box>

                            <Box style={{marginTop: '5px'}}>
                                { filesError  ? (
                                    <Alert severity="error">{filesError}</Alert>
                                ) :  (
                                    <Alert severity="info" className={classes.supportedFiles}>{`Supported files: ${fileAllowedExtensions.join()}`}</Alert>
                                )}
                            </Box>
                    </Stack>
                ))
                : ''
                }
            </CommonDialogBox>
		</>
  	)
}

export default CreateObjPanel